import React from 'react';
import PropTypes from 'prop-types';
import { StyledOrderItem, ButtonOrder, InputOrder, OrderIcon } from './style';
import { Triangle, TriangleDown } from '../../../../assets/images/index';

const OrderItem = ({
  className,
  onChange,
  onClickDown,
  onClickUp,
  order,
  id
}) => (
  <StyledOrderItem className={className}>
    <ButtonOrder onClick={onClickDown} id={`order-down-${id}`}>
      <OrderIcon size="xs" color="dark" svg={TriangleDown} hover />
    </ButtonOrder>
    <InputOrder name="order" type="text" value={order} onChange={onChange} />
    <ButtonOrder onClick={onClickUp} id={`order-up-${id}`}>
      <OrderIcon size="xs" color="dark" svg={Triangle} hover />
    </ButtonOrder>
  </StyledOrderItem>
);

OrderItem.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
  onClickUp: PropTypes.func,
  onClickDown: PropTypes.func,
  order: PropTypes.number,
  id: PropTypes.string
};

OrderItem.defaultProps = {
  onChange: e => e,
  order: 0
};

export default OrderItem;
